import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheckIcon, ChevronDownIcon } from 'lucide-react';
const faqData = [{
  question: '¿Cómo recibo el material después de la compra?',
  answer: 'El acceso es inmediato y automático. Una vez aprobado el pago, recibirás un correo electrónico con el enlace de descarga directamente al mail que registraste al momento de pagar. Revisá siempre tu carpeta de "Promociones" o "SPAM".'
}, {
  question: '¿El producto es físico o digital?',
  answer: 'Vendemos exclusivamente PLANOS Y EBOOKS DIGITALES en formato PDF de alta resolución. No enviamos productos físicos ni herramientas por correo postal.'
}, {
  question: '¿Necesito herramientas costosas para empezar?',
  answer: 'No. Nuestros manuales están diseñados para que optimices recursos, ahorres en costos de materiales y puedas trabajar con herramientas básicas de taller o electricidad.'
}, {
  question: '¿El pago es por única vez o es una suscripción?',
  answer: 'Es un pago único. No hay cuotas mensuales ni cobros ocultos. Tenés acceso de por vida al material y a todas sus futuras actualizaciones.'
}, {
  question: '¿Es seguro pagar con Mercado Pago?',
  answer: 'Totalmente. Utilizamos Mercado Pago como pasarela oficial, lo que garantiza que tus datos bancarios están encriptados y tu compra protegida al 100%.'
}];
export function GuaranteeSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#FDFBF7]" data-id="element-161">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        {/* Guarantee Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-[#2D5A27]/10 rounded-3xl p-8 md:p-12 text-center mb-16 shadow-sm" data-id="element-163">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-6 bg-[#EAEAEA]" data-id="element-164">
            <ShieldCheckIcon className="w-10 h-10 text-[#2D5A27] bg-[#EAEAEA]" data-id="element-165" />
          </div>
          <h2 className="text-2xl md:text-3xl font-extrabold font-sans uppercase mb-4" data-id="element-166">
            <span className="text-[#0099FF]" data-id="element-167">
              Garantía de Satisfacción con{' '}
            </span>
            <span className="text-[#0099FF]" data-id="element-168">0 Riesgo</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed font-sans" data-id="element-169">
            Estamos seguros que Boba Professional superará tus expectativas. Te
            ofrecemos{' '}
            <strong className="text-[#2D5A27]" data-id="element-170">7 días de garantía total</strong>
            . Si no es lo que esperabas, te reembolsamos el 100% de tu dinero
            sin hacer preguntas.
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-171">
          <h3 className="text-2xl font-extrabold text-center text-[#2D5A27] font-sans uppercase mb-8" data-id="element-172">
            Preguntas Frecuentes
          </h3>
          <div className="space-y-4" data-id="element-173">
            {faqData.map((faq, index) => <div key={index} className="bg-white border border-[#E8E0D5] rounded-2xl overflow-hidden transition-colors hover:border-[#D4A574]/50" data-id="element-174">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-175">
                  <span className="font-semibold text-[#2D5A27] pr-4 font-sans" data-id="element-176">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-[#8B6914] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-177" />
                </button>
                <AnimatePresence data-id="element-178">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-179">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-3 font-sans" data-id="element-180">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}